import { Injectable } from "@angular/core";

import { SystemConfigurationService } from "../../main/system-configuration";
import { NhsSettings } from "../../main/system-configuration/classes/nhs-settings";
import { UUID } from "angular2-uuid";
import { AppStorage } from "@bbwt/utils/app-storage";

@Injectable({
    providedIn: "root"
})
export class NhsLoginService {
    private nhsSettings: NhsSettings;

    constructor(private systemConfigurationService: SystemConfigurationService) {
        this.systemConfigurationService.getNhsSettings().then(result => (this.nhsSettings = result));
    }

    async redirectToNhsLogin(): Promise<void> {
        const nonce = UUID.UUID();
        // AppStorage.setItemForSession(AppStorage.NhsNonceKey, nonce + "asdf");
        AppStorage.setItemForSession(AppStorage.NhsNonceKey, nonce);
        var redirectLink = this.uriBuilder(`${this.nhsSettings.authorityUrl}/authorize`, [
            { key: "client_id", value: this.nhsSettings.clientId },
            { key: "scope", value: "openid gp_integration_credentials profile email profile_extended" },
            { key: "response_type", value: "code" },
            { key: "redirect_uri", value: encodeURI(NhsLoginService.redirectUrl) },
            { key: "vtr", value: JSON.stringify(this.nhsSettings.voT) },
            { key: "nonce", value: nonce }
        ]);
        window.location.href = redirectLink;
    }

    redirectToLoginSettings(): void {
        window.open(this.nhsSettings.loginSettingsUrl, "_blank");
    }

    private uriBuilder(url, queries): string {
        var newUrl = url;
        queries = queries || [];
        for (var i = 0; i < queries.length; i++) {
            newUrl = newUrl + (i === 0 ? "?" : "&");
            newUrl = newUrl + encodeURIComponent(queries[i].key) + "=" + encodeURIComponent(queries[i].value);
        }
        return newUrl;
    }

    public static get redirectUrl() {
        return window.location.origin + window.location.pathname;
    }
}
